import { configureStore } from "@reduxjs/toolkit";
import notificationsReducer from "./notifications";
import { saveState, loadState } from "../helper";

const preloadedState = loadState();

const store = configureStore({
  reducer: {
    notifications : notificationsReducer,
  },
  preloadedState, 
});

store.subscribe(() => {
  saveState({
    notifications: store.getState().notifications,
  });
});

export default store;
